import { Checkbox, Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import '../../css/immocom.css';
import { DataAPIBaliseRetour } from '../../data/DataAPIBaliseRetour';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAPIBaliseRetour } from '../ComboBox/ComboBoxAPIBaliseRetour';
import { ComboBoxAttributClasseCoucheMetier } from '../ComboBox/ComboBoxAttributClasseCoucheMetier';
import { ComboBoxClasseCoucheMetier } from '../ComboBox/ComboBoxClasseCoucheMetier';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
******************************************************************************************************
PROPS :
    ATTRIBUTS :
        int     idAPI                       id de l'API à laquelle sera rattachée la balise de retour
        int?    idAPIBaliseRetour           id de de la balise de retour
        bool    isOpen                      détermine si panel ouvert ou non
        string  libelleBaliseRetour         libellé de la balise de retour
        string  nomTableProvenance          nom de la table (classe) de laquelle provient la balise de retour
        string  nomChampProvenance          nom du champs (souvent identique à libelleBaliseRetour)
        int     idAPIBaliseRetourParent     id de la balise parent

    METHODES :
        void    onDismiss                   méthode appelée lorsque l'utilisateur clique sur "Annuler"
        void    onMiseAJour                 méthode appelée lorsque l'utilisateur clique sur "Valider" ou "Supprimer"
******************************************************************************************************
*/

export class FicheAPIBaliseRetour extends Component {

    static defaultProps = {
        idAPIBaliseRetourParent: null,
        libelleBaliseRetour: "",
        nomChampProvenance: "",
        nomTableProvenance: "",
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.idAPIBaliseRetour;
    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement de la balise de retour en cours..."
        });

        const { idAPI, idAPIBaliseRetour } = this.props;
        const { libelleBaliseRetour, nomTableProvenance, nomChampProvenance, idAPIBaliseRetourParent } = this.state;
        const balise = { idAPI, idAPIBaliseRetour, libelleBaliseRetour, nomTableProvenance, nomChampProvenance, idAPIBaliseRetourParent };

        DataAPIBaliseRetour._onEnregistrementAPIBaliseRetour(balise)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    this.props.onMiseAJour();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });

    };

    _onChangeCheckbox = (e, isChecked) => {
        if (isChecked) this.setState(prevState => ({ libelleBaliseRetour: `Liste_${prevState.libelleBaliseRetour}` }));
        else this.setState(prevState => ({ libelleBaliseRetour: prevState.libelleBaliseRetour.replace("Liste_", "") }));
    };

    _onOpen = () => {
        const { libelleBaliseRetour, nomTableProvenance, nomChampProvenance, idAPIBaliseRetourParent } = this.props;
        this.setState(
            {
                libelleBaliseRetour, nomTableProvenance, nomChampProvenance, idAPIBaliseRetourParent,
                hideMessageBarError: true,
                hideMessageBarWarning: true,
                onActiveBoutonEnregistrer: false
            },
            this._onVerificationFormulaire
        );
    };

    _onRenderFooterContent = () => {
        const { onActiveBoutonEnregistrer } = this.state;
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._enregistrer} disabled={!onActiveBoutonEnregistrer}>Valider</PrimaryButton>
            {!this._estFicheOuverteEnModeCreation() && <PrimaryButton onClick={this._toggleDialogSuppression(true)}>Supprimer</PrimaryButton>}
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onVerificationFormulaire = () => {
        const { idAPI, idAPIBaliseRetour } = this.props;
        const { libelleBaliseRetour, nomTableProvenance, nomChampProvenance, idAPIBaliseRetourParent } = this.state;
        const balise = { idAPI, idAPIBaliseRetour, libelleBaliseRetour, nomTableProvenance, nomChampProvenance, idAPIBaliseRetourParent };
        Immocom.fiche()._validationFormulaire(this, "APIBaliseRetour", balise, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    _toggleDialogSuppression = (isOpen) => () => {
        this.setState({ afficherDialogSuppression: isOpen });
    };

    _supprimer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression de la balise en cours..."
        });

        const { idAPI, idAPIBaliseRetour } = this.props;
        let suppressionAPIBaliseRetour = DataAPIBaliseRetour._onSuppressionAPIBaliseRetour(idAPI, idAPIBaliseRetour);
        suppressionAPIBaliseRetour
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onMiseAJour);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
        this._toggleDialogSuppression(false)();

    };

    render = () => {

        const { idAPI, idAPIBaliseRetour, isOpen, onDismiss } = this.props;
        const { afficherDialogSuppression, libelleBaliseRetour, nomTableProvenance, nomChampProvenance, idAPIBaliseRetourParent } = this.state;
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();

        return <Fragment>

            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={`${estFicheOuverteEnModeCreation ? "Création" : "Modification"} d'une balise de retour`}
                isOpen={isOpen}
                onDismiss={onDismiss}
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.smallFixedFar}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack>

                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />

                    <ComboBoxClasseCoucheMetier
                        label="Table de provenance"
                        onChange={(event, option) => this.setState(
                            { nomTableProvenance: option.key, nomChampProvenance: "", libelleBaliseRetour: "" },
                            this._onVerificationFormulaire)
                        }
                        placeholder="Table de provenance"
                        required
                        selectedKey={nomTableProvenance}
                    />

                    <ComboBoxAttributClasseCoucheMetier
                        disabled={!nomTableProvenance}
                        label="Champs de provenance"
                        nomDeLaClasse={nomTableProvenance}
                        onChange={(event, option) => this.setState(
                            { nomChampProvenance: option.key, libelleBaliseRetour: option.key },
                            this._onVerificationFormulaire)
                        }
                        placeholder="Champs de provenance"
                        selectedKey={nomChampProvenance}
                    />

                    <Checkbox
                        checked={libelleBaliseRetour && libelleBaliseRetour.startsWith("Liste_")}
                        className="mt-2"
                        disabled={!nomChampProvenance}
                        label="Marquer comme liste"
                        onChange={this._onChangeCheckbox}
                    />

                    <EUITextField
                        label="Libellé"
                        maxLength={MaxLengths.apiBaliseRetour.libelleBaliseRetour}
                        onDelayedChange={(event, newValue) => this.setState({ libelleBaliseRetour: newValue }, this._onVerificationFormulaire)}
                        placeholder="Libellé"
                        required
                        value={libelleBaliseRetour}
                    />

                    <ComboBoxAPIBaliseRetour
                        disabled={!libelleBaliseRetour}
                        idAPI={idAPI}
                        idAPIBaliseRetour={idAPIBaliseRetour}
                        label="Parent"
                        onChange={(event, option) => this.setState({ idAPIBaliseRetourParent: option.key || null }, this._onVerificationFormulaire)}
                        selectedKey={idAPIBaliseRetourParent || 0}
                    />

                </Stack>

                <EUIDialog
                    buttons={[
                        <PrimaryButton key="delete" onClick={this._supprimer} text="Supprimer" />,
                        <DefaultButton key="cancel" onClick={this._toggleDialogSuppression(false)} text="Annuler" />
                    ]}
                    isOpen={afficherDialogSuppression}
                    message="Confirmez-vous la suppression de cette balise de retour ?"
                    onDismiss={this._toggleDialogSuppression(false)}
                    titre="Suppression d'une balise de retour"
                >
                    <strong>Attention : toutes les éventuelles balises de retour rattachées à la balise «&nbsp;{libelleBaliseRetour}&nbsp;» seront également supprimées.</strong>
                </EUIDialog>

            </Panel>

        </Fragment>;

    };

};